import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { StockTransferComponent } from '../stock-transfer/stock-transfer.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-damage-list',
  templateUrl: './stock-damage-list.component.html',
  styleUrls: ['./stock-damage-list.component.css']
})
export class StockDamageListComponent implements OnInit {

  public menu_item_id = '66';
  public edit_auth;
  public del_auth;

  private dp = [];
  report_result = {};

  displayedColumns = ['damage_no', 'sub_item_no', 'main_item_name', 'item_subcat_name', 'unit_name', 
    'damage_quantity', 'del'];  
    // 'main_item_name_en', , 'item_cat_name','stock_no', , 'view', 'expiry_date', 'available_count', 'edit', 'del'

  displayedColumns2 = ['damage_no', 'sub_item_no', 'main_item_name', 'item_subcat_name', 'unit_name', 
    'damage_quantity'];  
    // , 'expiry_date', 'available_count'
  dataSource = new MatTableDataSource(this.dp);

  transferDialogRef: MatDialogRef<StockTransferComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'type': 'damage_list', 'table_name': 'stock_damage', 'title': 'قائمة الإتلاف والاستهلاك'
  };

  // Store_Msg; Sub_Item_Msg; Sub_item_Placeholder; Branch_Msg;
  Damage_Consume_List; Sub_Item; Branch; Store; 
  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    // translate.get('Sub_item_Placeholder').subscribe((res: string) => {
    //   this.Sub_item_Placeholder = res;
    // });
    // this.search_obj['placeholder'] = this.Sub_item_Placeholder;

    // translate.get('Branch_Msg').subscribe((res: string) => {
    //   this.Branch_Msg = res;
    // });

    // translate.get('Store_Msg').subscribe((res: string) => {
    //   this.Store_Msg = res;
    // });

    // translate.get('Sub_Item_Msg').subscribe((res: string) => {
    //   this.Sub_Item_Msg = res;
    // });

    translate.get('Damage_Consume_List').subscribe((res: string) => {
      this.Damage_Consume_List = res;
    });
    this.model['title'] = this.Damage_Consume_List;

    translate.get('Sub_Item').subscribe((res: string) => {
      this.Sub_Item = res;
    });

    translate.get('Branch').subscribe((res: string) => {
      this.Branch = res;
    });

    translate.get('Store').subscribe((res: string) => {
      this.Store = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });
  }

  ngOnInit() {
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  onChangeRepResult = function (report_result: object) {
    console.log(report_result);
    this.report_result = report_result;

    this.dp = this.report_result['list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  // search() {
    // if (this.model['branch_id'] == '0') {
    //   alert(this.Branch_Msg);
    //   return false;
    // }

    // if (this.model['store_id'] == '0') {
    //   alert(this.Store_Msg);
    //   return false;
    // }

    // if (this.model['sub_item_no'] == '') {
    //   alert(this.Sub_Item_Msg);
    //   return false;
    // }

  //   let obj = {
  //     cmd: 'getStockDamageList', store_id: this.model['store_id'], sub_item_no: this.model['sub_item_no']
  //   };

  //   this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
  //     .subscribe(data => {
  //       this.applicationConstants.appComp.hideBusyCursor();

  //       this.dp = data.status.msg;
  //       this.dataSource = new MatTableDataSource(this.dp);
  //       this.dataSource.sort = this.sort;
  //     });

  // }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="50%"> ' + this.Branch + ': ' + 
      (this.applicationConstants.user_lang == 'ar' ? this.report_result['branch_name'] : this.report_result['branch_name_en']);
    html_data += '</td>';

    html_data += '<td width="50%"> ' + this.Store + ': ' + 
      (this.applicationConstants.user_lang == 'ar' ? this.report_result['store_name'] : this.report_result['store_name_en']);
    html_data += '</td></tr>';

    if (this.report_result['sub_item_name'] != '')
      html_data += '<tr><td colspan="2"> ' + this.Sub_Item + ': ' + this.report_result['sub_item_name'] + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('stock_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  editStockDamage(row) {
    let dialog_data = [{ data: row, type: row.damage_type }];
    this.transferDialogRef = this.dialog.open(StockTransferComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.transferDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          (document.getElementById('btn_search') as HTMLInputElement).click();
      });
  }

  // editStock(row) {
  //   let dialog_data = [{
  //     'table_name': 'stock', 'stock_id': row.stock_id,
  //     'stock_no': row.stock_no,
  //     'branch_id': row.branch_id,
  //     'store_id': row.store_id,
  //     'sub_item_id': row.sub_item_id,
  //     'quantity': row.quantity,
  //     'expiry_date': row.expiry_date,
  //     'comment': row.comment
  //   },
  //   {
  //     'sub_item_id': row.sub_item_id,
  //     'sub_item_no': row.sub_item_no,
  //     'main_item_name': row.main_item_name,
  //     'main_item_name_en': row.main_item_name_en,
  //     'item_cat_name': row.item_cat_name,
  //     'item_subcat_name': row.item_subcat_name,
  //     'quantity': row.quantity,
  //     'stock_no': row.stock_no,
  //     'expiry_date': row.expiry_date,
  //   }];
  //   this.addDialogRef = this.dialog.open(StockComponent, {
  //     hasBackdrop: false,
  //     data: dialog_data
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       this.search();
  //     });
  // }

  delStockDamage(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'damage_no': row.damage_no }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            (document.getElementById('btn_search') as HTMLInputElement).click();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
